import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getSize = (dsf_size) => {
  switch (dsf_size) {
    case "large":
      return "p-16";
    case "small":
      return "p-8";
    default:
      return "p-12";
  }
};
const getSpacerSize = ({ dsf_size }) => {
  switch (dsf_size) {
    case "large":
      return "m";
    case "small":
      return "xs";
    default:
      return "s";
  }
};
const getClasses = ({ dsf_size, dsf_selected, dsf_interactive }) => {
  const classes = ["flex", "flex-col", "items-start", "w-full", "rounded", "border", "shadow-xs"];
  classes.push(getSize(dsf_size));
  if (dsf_selected) {
    classes.push("border-secondary-100", "bg-secondary-50");
  } else {
    classes.push("border-neutral-100", "bg-neutral-0");
    if (dsf_interactive) {
      classes.push("hover:bg-neutral-50");
    }
  }
  return concatClasses(classes);
};
export {
  getClasses,
  getSpacerSize
};
